const INITIAL_STATE = {
    config: {
        isRestaurantsEnabled: false,
        isRestaurantsBookingEnabled: false,
        isActivitiesEnabled: false,
        isActivitiesBookingEnabled: false,
    },
    restaurantsAvailabilityByDate: {},
    activitiesAvailabilityByDate: {},
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_TAC_CONFIG':
            return {
                ...state,
                config: {
                    ...state.config,
                    ...(action.payload || {}),
                },
            };
        case 'SET_TAC_RESTAURANTS_AVAILABILITY':
            return {
                ...state,
                restaurantsAvailabilityByDate: action.payload || {},
            };
        case 'SET_TAC_ACTIVITIES_AVAILABILITY':
            return {
                ...state,
                activitiesAvailabilityByDate: action.payload || {},
            };
        default:
            return state;
    }
}
